
  import { NO_INFORMATION } from "@/data/placeholders";
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class PageHeadIcon extends Vue {
    @Prop({ type: String, default: undefined }) readonly icon?: string;
    @Prop({ type: String, default: undefined }) readonly content?: string;
    @Prop({ type: Boolean, default: false }) readonly extend!: boolean;

    noInformaion = NO_INFORMATION;

    get contentData(): string {
      if (this.content) {
        return this.content;
      }
      return this.noInformaion;
    }

    get contentStyles(): Object {
      if (this.content) {
        return {
          truncate: !this.extend,
          "block -mr-3 break-all": this.extend,
        };
      }
      return {};
    }
  }
